export default __webpack_public_path__ + "static/media/010503040404080808.d87f88b8.mp4";